(() => {
  const desktopPointer = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  const zoomLevel = 2.35;

  function getLargestSource(image) {
    const fallback = image.currentSrc || image.src || '';
    const srcset = image.getAttribute('srcset');

    if (!srcset) return fallback;

    let bestUrl = fallback;
    let bestWidth = 0;

    srcset.split(',').forEach((candidate) => {
      const parts = candidate.trim().split(/\s+/);
      const url = parts[0];
      const descriptor = parts[1] || '';
      const width = descriptor.endsWith('w') ? parseInt(descriptor, 10) : 0;

      if (url && width >= bestWidth) {
        bestUrl = url;
        bestWidth = width;
      }
    });

    return bestUrl;
  }

  function syncMagnifiedImage(sourceImage, magnifiedImage) {
    const source = getLargestSource(sourceImage);
    const styles = window.getComputedStyle(sourceImage);

    if (source && magnifiedImage.src !== source) {
      magnifiedImage.src = source;
    }

    magnifiedImage.style.objectFit = styles.objectFit;
    magnifiedImage.style.objectPosition = styles.objectPosition;
  }

  function moveMagnifier(event, host, media, layer, ring, magnifiedImage) {
    const rect = media.getBoundingClientRect();

    if (!rect.width || !rect.height) return;

    const x = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
    const y = Math.max(0, Math.min(event.clientY - rect.top, rect.height));

    layer.style.setProperty('--fm-lens-x', `${x}px`);
    layer.style.setProperty('--fm-lens-y', `${y}px`);

    ring.style.left = `${x}px`;
    ring.style.top = `${y}px`;

    magnifiedImage.style.transformOrigin = `${x}px ${y}px`;
    magnifiedImage.style.transform = `scale(${zoomLevel})`;

    host.classList.add('is-magnifying');
  }

  function initMagnifier(host) {
    if (!desktopPointer.matches) return;
    if (host.dataset.fmMagnifierReady === 'true') return;
    if (host.closest('.dialog-zoomed-gallery')) return;

    const media = host.querySelector('.product-media');
    const sourceImage = media?.querySelector('.product-media__image');

    if (!media || !sourceImage) return;

    host.dataset.fmMagnifierReady = 'true';
    host.classList.add('fm-magnifier-ready');

    const layer = document.createElement('div');
    layer.className = 'fm-product-magnifier__layer';
    layer.setAttribute('aria-hidden', 'true');

    const magnifiedImage = sourceImage.cloneNode(false);
    magnifiedImage.className = 'fm-product-magnifier__image';
    magnifiedImage.alt = '';
    magnifiedImage.removeAttribute('id');
    magnifiedImage.removeAttribute('srcset');
    magnifiedImage.removeAttribute('sizes');
    magnifiedImage.removeAttribute('loading');
    magnifiedImage.removeAttribute('fetchpriority');
    magnifiedImage.removeAttribute('ref');
    magnifiedImage.setAttribute('aria-hidden', 'true');
    magnifiedImage.draggable = false;
    magnifiedImage.decoding = 'async';

    syncMagnifiedImage(sourceImage, magnifiedImage);
    layer.appendChild(magnifiedImage);

    const ring = document.createElement('div');
    ring.className = 'fm-product-magnifier__ring';
    ring.setAttribute('aria-hidden', 'true');

    media.append(layer, ring);

    host.addEventListener('pointerenter', (event) => {
      syncMagnifiedImage(sourceImage, magnifiedImage);
      moveMagnifier(event, host, media, layer, ring, magnifiedImage);
    });

    host.addEventListener('pointermove', (event) => {
      moveMagnifier(event, host, media, layer, ring, magnifiedImage);
    });

    host.addEventListener('pointerleave', () => {
      host.classList.remove('is-magnifying');
    });
  }

  function initAll(root = document) {
    if (!desktopPointer.matches) return;

    root.querySelectorAll(
      'media-gallery .product-media-container--image.product-media-container--zoomable:not(.dialog-zoomed-gallery *)'
    ).forEach(initMagnifier);
  }

  function startObserver() {
    const observer = new MutationObserver((mutations) => {
      if (!desktopPointer.matches) return;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (
            node.matches?.('media-gallery, .product-media-container--image') ||
            node.querySelector?.('media-gallery, .product-media-container--image')
          ) {
            initAll(node.matches?.('media-gallery') ? node : node.parentElement || document);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function boot() {
    initAll();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  desktopPointer.addEventListener?.('change', (event) => {
    if (event.matches) initAll();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
